/** Canonical form lifecycle statuses used across the app. */

export const FORM_STATUS = {
  DRAFT: "draft",
  PUBLISHED: "published",
  PAUSED: "paused",
};

/** Legacy / alternate values still present in production data. */
const ACTIVE_ALIASES = new Set([
  FORM_STATUS.PUBLISHED,
  "Active",
  "active",
  "Published",
]);

const PAUSED_ALIASES = new Set([
  FORM_STATUS.PAUSED,
  "Paused",
  "inactive",
  "Inactive",
]);

export const isFormActive = (status) => ACTIVE_ALIASES.has(status);

export const isFormPaused = (status) => PAUSED_ALIASES.has(status);

export const normalizeFormStatus = (status) => {
  if (isFormActive(status)) return FORM_STATUS.PUBLISHED;
  if (isFormPaused(status)) return FORM_STATUS.PAUSED;
  return status || FORM_STATUS.DRAFT;
};

/** Count forms that consume the active-form plan limit. */
export const countActiveForms = (forms = []) =>
  forms.filter((f) => isFormActive(f?.status)).length;
